<ul class="navbar-nav ms-auto">
  <li>
    <div style="color: #7b4918;">
      <span>{{branchName}}</span>
    </div>
  </li>
  <li>
    <div class="dropdown" ngbDropdown placement="auto" #notificationDropdown="ngbDropdown">
      <a ngbDropdownToggle href="javascript:"><i class="icon feather icon-bell notification" title="Notification">
      <span class="notification-badge">{{notificationData.length}}</span></i></a>
      <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end notification">
        <div class="noti-head">
          <h6 class="d-inline-block m-b-0" title="notification">Notifications</h6>
          <!-- <div class="float-end">
            <a href="javascript:" class="m-r-10">mark as read</a>
            <a href="javascript:">clear all</a>
          </div> -->
        </div>
        <ul class="noti-body">
          @for (notification of notificationData; track notification) {
          <li class="notification">
            <a href="javascript:" (click)="notificationClick(notification)">
            <div class="media">
              <!-- <img class="img-radius" src="assets/images/user/avatar-1.jpg" alt="Generic placeholder image" /> -->
              <div class="media-body">
                <!-- <p><strong>Rinkall Patel</strong><span class="n-time text-muted"><i
                      class="icon feather icon-clock m-r-10"></i>30 min</span></p> -->
                <p>{{notification.message}}</p>
              </div>
            </div>
            </a>
          </li>
        }
        </ul>
        <!-- <div class="noti-footer">
          <a href="javascript:">show all</a>
        </div> -->
      </div>
    </div>
  </li>
  <!-- <li (click)="this.visibleUserList = !this.visibleUserList">
    <div class="dropdown">
      <a href="javascript:" class="displayChatbox dropdown-toggle">
        <i class="icon feather icon-mail" title="Mail InBox"></i><span class="badge bg-success"><span class="sr-only"></span></span>
      </a>
    </div>
  </li> -->
  <li>
    <div class="dropdown" ngbDropdown placement="auto">
      <a class="drp-user" href="javascript:" ngbDropdownToggle>
        <img [src]="profileImage" class="img-radius wid-40" />
        <div class="user-name-hover">
          <div class="d-flex align-items-center">
            <span class="me-3">
              <i class="feather icon-user fw-bold text-primary"></i>
            </span>
            <span class="name">{{userName}}</span>
          </div>
        </div>
        <!-- <img [src]="profileImage" class="img-radius wid-40"  title="{{userName}}"/> -->
      </a>
      <div class="dropdown-menu dropdown-menu-end profile-notification" ngbDropdownMenu>
        <div class="pro-head">
          <img [src]="profileImage" class="img-radius" />
          <span>{{userName}}</span>
          <a (click)="logout()" class="dud-logout" title="Logout">
            <i class="feather icon-log-out"></i>
          </a>
        </div>
        <ul class="pro-body">
          <li>
            <button [routerLink]="'/component/profile'" class="dropdown-item"><i class="feather icon-user"></i>
              Profile</button>
          </li>
          <li>
            <button [routerLink]="'/component/change-password'" class="dropdown-item">
              <i class="feather icon-lock"></i>
              Change password</button>
          </li>
          <li *ngIf="isadmin">
            <button [routerLink]="'/auth/screen'" class="dropdown-item">
              <i class="feather icon-lock"></i>
              Swap Store/Warehouse</button>
          </li>
          <!-- <li>
            <button (click)="logout()" class="dropdown-item"><i class="feather icon-lock"></i>
              Log Out</button>
          </li> -->
        </ul>
      </div>
    </div>
  </li>
</ul>

@if (visibleUserList) {
<section class="header-user-list" [ngClass]="{ open: visibleUserList }" [@slideInOutLeft]>
  <app-chat-user-list (ChatToggle)="onChatToggle($event)"
    (ChatCollapse)="this.visibleUserList = !this.visibleUserList; this.chatMessage = false"></app-chat-user-list>
</section>
}

@if (chatMessage) {
<section class="header-chat" [ngClass]="{ open: chatMessage }" [@slideInOutLeft]>
  <app-chat-msg (ChatToggle)="this.chatMessage = !this.chatMessage" [friendId]="friendId"></app-chat-msg>
</section>
}

@if (visibleUserList) {
<section class="header-user-list" [ngClass]="{ open: visibleUserList }" [@slideInOutRight]>
  <app-chat-user-list (ChatToggle)="onChatToggle($event)"
    (ChatCollapse)="this.visibleUserList = !this.visibleUserList; this.chatMessage = false"></app-chat-user-list>
</section>
}

@if (chatMessage) {
<section class="header-chat" [ngClass]="{ open: chatMessage }" [@slideInOutRight]>
  <app-chat-msg (ChatToggle)="this.chatMessage = !this.chatMessage" [friendId]="friendId"></app-chat-msg>
</section>
}